import Cookies from 'js-cookie';
import { apiEndpoints, ENV_STAGES, queryParams } from '../constants/ApiConstants';
import { currentHostName, getCurrentStageAndConfig } from '../StageConfig';
import axios from 'axios';
import { redirectToSignInPage } from './loginUser';

export const getPosSessionIdFromCloud = async () => {
  const shopIdFromStorage = localStorage.getItem("shopId");
  // Redirect to Sign-in page if ShopId is not present in the localStorage
  const shopId = shopIdFromStorage ? +shopIdFromStorage : redirectToSignInPage();
  const posSessionParams: any = {
    shopId: shopId,
    tillNumber: -3,
  };
  try {
    const { config } = getCurrentStageAndConfig()
    const { smartPosUrl } = config
    const response = await axios.post(
      `${smartPosUrl}${apiEndpoints.login}${queryParams.posSession}`,
      posSessionParams, { withCredentials: true}
    );
    const { posSessionId } = response.data;
    if (currentHostName === ENV_STAGES.PROD) {
      Cookies.set("posSessionId", posSessionId, { domain: ".amazon.in" });
    } else {
      Cookies.set("posSessionId", posSessionId, {
        domain: ".amazon.com",
      });
    }
  } catch (error) {
    return null;
  }
  return null;
};
